/*
     Title: Constant for EXTERNAL_PROCESS
     Description: Constant for EXTERNAL_PROCESS
     Author: Iqbal Hossain
     Date: 24-January-2022
     Modified: 24-January-2022
*/

export const FETCH_EXTERNAL_PROCESS = 'FETCH_EXTERNAL_PROCESS';
export const FETCH_EXTERNAL_PROCESS_BY_QUERY = 'FETCH_EXTERNAL_PROCESS_BY_QUERY';
export const FETCH_EXTERNAL_PROCESS_BY_ID = 'FETCH_EXTERNAL_PROCESS_BY_ID';
export const FETCH_EXTERNAL_PROCESS_BY_RANGE = 'FETCH_EXTERNAL_PROCESS_BY_RANGE';

/** Change Log
 * 24-Jan-2022(Iqbal): Add FETCH_EXTERNAL_PROCESS_BY_QUERY, , FETCH_EXTERNAL_PROCESS, FETCH_EXTERNAL_PROCESS_BY_ID, FETCH_EXTERNAL_PROCESS_BY_RANGE
 */
